import { TypeDiffusionEnum } from './enums/type-diffusion.enum';
import { TypeFluxEnum } from './enums/type-flux.enum';
import { EnumTypeZoneGeographique } from './enums/type-zone-geograpique.enum';
import { ZoneGeographiqueEnum } from './enums/zone-geographique.enum';

export class Diffuseur {
  constructor() {}

  public id: number;
  public code: string;
  public intitule: string;
  public typeZone: EnumTypeZoneGeographique;
  public support: string;
  public typeSupport: TypeDiffusionEnum;
  public zoneGeographique: ZoneGeographiqueEnum;
  public contact: string;
  public email: string;
  public telephone: string;
  public groupe: string;
  public typeFlux: TypeFluxEnum;
  public siretFacturation: string;
}
